var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDiamond = function SvgDiamond(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    d: "M11.8028 21.7788L1 8.13574H7.6229L11.8028 21.7788Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    fillOpacity: 0.6,
    d: "M11.8025 21.7788L7.59961 8.13574H16.4938L11.8025 21.7788Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    fillOpacity: 0.4,
    d: "M22.9996 8.13574L11.8027 21.7788L16.4227 8.13574H22.9996Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    fillOpacity: 0.3,
    d: "M7.62248 8.36203L4.51953 2.22266H11.9994L7.62248 8.36203Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    fillOpacity: 0.1,
    d: "M19.4799 2.22266L16.4229 8.36203L12 2.22266H19.4799Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    fillOpacity: 0.7,
    d: "M1 8.13464H7.59991L4.53567 2.22266L1 8.13464Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    fillOpacity: 0.4,
    d: "M7.59961 8.13464H16.3995L11.9996 2.22266L7.59961 8.13464Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00696F",
    fillOpacity: 0.2,
    d: "M16.4004 8.13464H23.0003L19.3795 2.22266L16.4004 8.13464Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiamond);
export default ForwardRef;